/** Scoring model behind a stated credit score (stored in credit_score_source); Vantage converts to FICO later. */
export enum CreditScoreModel {
  Fico = 'fico',
  Vantage = 'vantage',
}

export const CREDIT_SCORE_MODEL_LABELS: Record<CreditScoreModel, string> = {
  [CreditScoreModel.Fico]: 'FICO',
  [CreditScoreModel.Vantage]: 'VantageScore (Credit Karma)',
}

/** Partner tiers are FICO bands and the engine has no conversion yet, so the UI says so. */
export const VANTAGE_COMPARED_AS_FICO_NOTE =
  'Partner guidelines use FICO thresholds. Until a conversion exists, this VantageScore is compared as entered.'
